<template>
<div class="app">
  <router-view></router-view>
</div>
</template>
<script>
export default {
  name: "app",
  created() {
    this.$store.getters.api.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response.status == 401) {
        this.$store.dispatch('user/logout')
        this.$router.push('/login');
      }
      return Promise.reject(error);
    });
  }
};
</script>

<style lang="scss">
  @import 'assets/scss/style';
</style>




